import { MessageBubble, MessageText } from '@engyalo/design-system';
import React from 'react';
import { MessageArea } from './styled';
import { ChatMessageComponentProps } from '../ChatMessage';

export enum MessageVariant {
  AGENT = 'agent',
  USER = 'user',
  FLOW = 'flow',
  INTERNAL = 'internal',
}

export const MESSAGE_VARIANT_MAP: Record<string, MessageVariant> = {
  agent: MessageVariant.AGENT,
  user: MessageVariant.USER,
  bot: MessageVariant.FLOW,
};

export enum MessageType {
  TEXT_ONLY = 'text-only',
}

const TextMessage: React.FC<ChatMessageComponentProps> = (props) => {
  const { authorRole, text, displayName, sentAt, messageStatus, error } = props;
  const body = text?.body || '';

  return (
    <MessageArea>
      <MessageBubble
        style={{ marginTop: 0 }}
        data-testid="text-message"
        variant={error ? 'error' : MESSAGE_VARIANT_MAP[authorRole]}
        displayName={displayName}
        sentAt={sentAt}
        status={messageStatus}
      >
        <MessageText body={body} />
      </MessageBubble>
    </MessageArea>
  );
};

export default TextMessage;
